export default "__VITE_ASSET__B9LG6u8q__"